import * as Apollo from '@apollo/react-hooks'
import { History } from 'history'
import * as React from 'react'
import { RouteComponentProps } from 'react-router-dom'

import { homePath } from 'main/routes/home'
import { SCHOOL_PAGE_QUERY, SchoolPage as SchoolPageData } from './gql'
import SchoolPage from './SchoolPage'

interface IRouteParams {
  schoolId: string
}

export default function School(props: RouteComponentProps<IRouteParams>) {
  const { history, match } = props
  const variables = {
    schoolId: getSchoolId(match.params),
  }

  const result = Apollo.useQuery(SCHOOL_PAGE_QUERY, {
    variables,
    onCompleted: data => handleQueryComplete(data, history),
  })

  return <SchoolPage result={result} />
}

function handleQueryComplete(data: SchoolPageData, history: History): void {
  const dataExists: boolean = !!(data?.school && data?.school?.director)
  if (dataExists) return

  history.push(homePath())
}

function getSchoolId(params: IRouteParams) {
  const schoolId = parseInt(params.schoolId, 10)
  if (Number.isNaN(schoolId)) {
    throw new Error(`school id ${params.schoolId} is invalid`)
  }

  return schoolId
}
